import { SimpleIconProps } from '../types';

export const IconSomeInventory = ({ className, color }: SimpleIconProps) => (
  <svg
    className={className}
    fill={color}
    height="20"
    role="img"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.25 1.66406V4.16406H8.75V1.66406H6.25V9.16406H13.75V1.66406H11.25Z" />
    <path d="M10.4168 1.66406H9.5835V3.33073H10.4168V1.66406Z" fill="#101820" />
    <path d="M6.6665 10.8281V13.3281H5.83317H4.99984H4.1665V10.8281H1.6665V18.3281H9.1665V10.8281H6.6665Z" />
    <path d="M5.83333 10.8281H5V12.4948H5.83333V10.8281Z" fill="#101820" />
    <path d="M15.833 10.8281V13.3281H13.333V10.8281H10.833V18.3281H18.333V10.8281H15.833Z" />
    <path d="M14.9998 10.8281H14.1665V12.4948H14.9998V10.8281Z" fill="#101820" />
  </svg>
);
